const getQueryParameterByType = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const customerSection = async () => {
    let queryValue = getQueryParameterByType('type');

    queryValue = queryValue ?? 'information'

    const sectionName = "customer" + '-' + queryValue

    fetch(window.Shopify.routes.root + `?sections=${sectionName}`)
        .then((res) => {
            return res.json()
        }).then((html) => {
            const section__rendering__ = document.getElementById('section__rendering')
            if( section__rendering__ && queryValue !== 'wishlist' && queryValue !== 'orders' ) document.getElementById('section__rendering').innerHTML = html[sectionName]
            if (queryValue == 'addresses') {
                  customerAddressFormEdited()
            }
          
        })
}

const customerAddressFormEdited = () => {
    var newAddressForm = document.getElementById('AddressNewForm');
    var addressForms = document.querySelectorAll('.js-address-form');

    if (!newAddressForm || !addressForms.length) {
        return;
    }

    // Country/province selector can take a short time to load
    setTimeout(function () {
        document.querySelectorAll('.js-address-country').forEach(el => {
            var countryId = el.dataset.countryId;
            var provinceId = el.dataset.provinceId;
            var provinceContainerId = el.dataset.provinceContainerId;

            new Shopify.CountryProvinceSelector(
                countryId,
                provinceId, {
                    hideElement: provinceContainerId
                }
            );
        });
    }, 1000);

    // Toggle new/edit address forms
    document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function () {
            newAddressForm.classList.toggle('hide');
        });
    });

    document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function (evt) {
            var formId = evt.currentTarget.dataset.formId;
            document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
    });

    document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function (evt) {
            var formId = evt.currentTarget.dataset.formId;
            var confirmMessage = evt.currentTarget.dataset.confirmMessage;

            if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
                if (Shopify) {
                    Shopify.postLink('/account/addresses/' + formId, {
                        parameters: {
                            _method: 'delete'
                        }
                    });
                }
            }
        })
    });
}

const recoverPassword = () => {
  console.log('recoverPassword')
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
  
     function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
}


if(window.location.href.indexOf("/account/login") > -1) {
  recoverPassword()
}

if (window.location.href.indexOf("account") > -1) {
    customerSection()
}

localStorage.setItem('estimated_try_at_home', "In Stock! Estimated Delivery Date ")
localStorage.setItem('estimated_special_order', "Estimated Shipping Date")